// @flow
import * as React from 'react';
import SelectInput from 'components/SelectInput';
import { updateObject } from 'utils/functional';
import Field from './Field';

const SelectField = ({
  name,
  label,
  description,
  options,
  noWrap,
  onUpdateValue,
  ...props
}: {
  name: string,
  label?: React.Node,
  description?: string,
  options: $ReadOnlyArray<{ value: ?string, label: string, ... }>,
  onUpdateValue?: mixed => void,
  noWrap?: boolean
}) => (
  <Field
    inputProps={updateObject(props, { options })}
    name={name}
    label={label}
    description={description}
    noWrap={noWrap}
    renderInput={({ value, id, qaId, hasError, updateValue }) => {
      const update = v => {
        updateValue(v);
        if (onUpdateValue) {
          onUpdateValue(v);
        }
      };

      return (
        <SelectInput
          id={id}
          name={name}
          value={value || ''}
          options={options}
          hasError={hasError}
          data-qa-id={qaId}
          onChange={update}
          {...props}
        />
      );
    }}
  />
);

export default SelectField;
